import type { PImage } from '../../engine/aliases'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { rando } from '../../lib/rando-sidecar'
import { ILargeSprite, largeSprites } from '../../sprites/largeSprites'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { chessCamera } from './chessCamera-sidecar'
import { chessLayers } from './chessLayers-sidecar'

export interface IChessBackground {
  image: PImage
  lastLargeImage: ILargeSprite
}

let _obj: IChessBackground | null = null
export function get() {
  if (!_obj) {
    _obj = create()
  }
  return _obj
}

export function getRandomImage(exclude: ILargeSprite | null) {
  let images = [
    largeSprites.hiddenTempleFull,
    largeSprites.redFortressFull,
    largeSprites.eeriePathFull,
    largeSprites.quietMonasteryFull,
    largeSprites.riverCastleFull,
  ]
  if (exclude) {
    l.remove(images, exclude)
  }
  return rando.sample(images)
}

export function create(): IChessBackground {
  let lastLargeImage = getRandomImage(null)

  let image = spritesUtil.createLargeSprite(
    chessLayers.getLayers().background,
    lastLargeImage,
  )

  image.scale = 0.5
  // image.alpha = 0.25

  let obj: IChessBackground = {
    image,
    lastLargeImage,
  }
  _obj = obj
  return obj
}

export function switchImage() {
  let obj = get()
  obj.lastLargeImage = getRandomImage(obj.lastLargeImage)
  spritesUtil.setLargeSprite(obj.image, obj.lastLargeImage)
}

export function update() {
  let obj = get()
  let gb = chessCamera.getGameBounds()

  let fr = obj.image.frame

  let scaleX = gb.width / fr.width
  let scaleY = gb.height / fr.height

  let scale = mathUtils.max(scaleX, scaleY)

  let ox = -(fr.width * scale - gb.width) / 2
  let oy = -(fr.height * scale - gb.height) / 2

  obj.image.scale = scale
  obj.image.x = ox
  obj.image.y = oy
}
